import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navigation from "./Navigation";
import SizeupButton from "./SizeupButton";
import selfAssessmentImg from "../assets/selfassesment.png";

const questions = [
  "Are you feeling like a burden to your family, friends, Fire, EMS or law enforcement organization?",
  "Do you feel the world would be a better place without you in it?",
  "Have you started to isolate yourself from others in the firehouse. police station or EMS location? At Home?",
  "Have you found yourself turning to alcohol or other addictive behaviors to make yourself feel better?",
  "Have you or someone close to you noticed that your sleeping patterns have changed?",
  "Are you thinking, “What’s the use?” when going to station or responding on calls?",
  "Do you find yourself thinking about or performing unnecessary risks while at a scene or on an emergency incident?",
  "Have you found an increased or new interest in risky activities outside the firehouse/EMT/law enforcement organization such as sky-diving, reckless motorcycle riding, or purchasing guns?",
  "Are you displaying unexplained angry emotions or have you been disciplined recently for anger towards others?",
  "Have you been told that “you have changed” by friends, family, or coworkers?",
  "Does your family have a history of suicide?",
  "Do you have a history of feeling depressed?",
  "Do you have feelings of hopelessness?",
  "Do you feel like killing yourself?",
  "Have you created plans to kill yourself?",
  "Have you recently attempted to kill yourself?",
];

const Sizeup = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [answers, setAnswers] = useState(Array(questions.length).fill(null));
  const [score, setScore] = useState(0);
  const navigate = useNavigate();

  const handleAnswer = (index, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index] = value;
    setAnswers(updatedAnswers);
  };

  const handleNext = () => {
    if (answers[currentSlide] === null) {
      alert("Please answer the question before proceeding.");
      return;
    }
    if (currentSlide < questions.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      const totalScore = answers.filter((a) => a === "Yes").length;
      setScore(totalScore);
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) setCurrentSlide(currentSlide - 1);
  };

  const findMyState = () => {
    const success = (position) => {
      const { latitude, longitude } = position.coords;
      const geoApiUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`;

      fetch(geoApiUrl)
        .then((res) => res.json())
        .then((data) => findCounselor(data.principalSubdivision));
    };

    const error = () => {
      console.error("Error getting user location");
    };

    navigator.geolocation.getCurrentPosition(success, error);
  };

  const findCounselor = async (state) => {
    try {
      const response = await axios.get(`/api/counselors/${state}`);
      if (response.data.length > 0) {
        navigate("/booking", { state: { counselor: response.data[0] } });
      } else {
        alert("Coming soon to your state");
      }
    } catch (error) {
      console.error("Error fetching counselor:", error);
    }
  };

  const handleCallClick = (type) => {
    const numbers = {
      caseworker: "866-435-4376",
      suicide: "988",
      "911": "911",
    };
    const confirmCall = window.confirm(`Do you want to call ${numbers[type]}?`);
    if (confirmCall) window.location.href = `tel:${numbers[type]}`;
  };

  const isHighRisk =
    answers[13] === "Yes" || answers[14] === "Yes" || answers[15] === "Yes";

  const getRecommendation = () => {
    if (isHighRisk) {
      return (
        <div className="text-center">
          <p className="mb-4 text-red-600 font-semibold">
            Seek help immediately by dialing 911 or calling the Suicide Lifeline.
          </p>
          <div className="flex flex-col gap-4 items-center">
            <SizeupButton
              btnClickHandler={() => handleCallClick("suicide")}
              btnText="Call Suicide Lifeline"
              className="hover:bg-black hover:text-white"
            />
            <SizeupButton
              btnClickHandler={() => handleCallClick("911")}
              btnText="Call 911"
              className="hover:bg-black hover:text-white"
            />
          </div>
        </div>
      );
    }

    if (score >= 3) {
      return (
        <div className="text-center">
          <p className="mb-4">We recommend connecting with a local counselor or caseworker.</p>
          <div className="flex flex-col gap-4 items-center">
            <SizeupButton
              btnClickHandler={findMyState}
              btnText="Find Counselor"
              className="hover:bg-black hover:text-white"
            />
            <SizeupButton
              btnClickHandler={() => handleCallClick("caseworker")}
              btnText="Call Caseworker"
              className="hover:bg-black hover:text-white"
            />
          </div>
        </div>
      );
    }

    return (
      <div className="text-center">
        <p className="mb-4">You are not showing immediate risk. Stay proactive about your mental health.</p>
        <div className="flex flex-col gap-4 items-center">
          <SizeupButton
            btnClickHandler={findMyState}
            btnText="Find Counselor"
            className="hover:bg-black hover:text-white"
          />
          <SizeupButton
            btnClickHandler={() => handleCallClick("caseworker")}
            btnText="Call Caseworker"
            className="hover:bg-black hover:text-white"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navigation />
      <div className="flex flex-grow items-center justify-center px-4">
        <div className="w-full max-w-2xl bg-white shadow-md rounded-xl p-8 space-y-6">
          {currentSlide < questions.length ? (
            <>
              <h2 className="text-lg font-semibold">
                Question {currentSlide + 1} of {questions.length}
              </h2>
              <p className="text-gray-700">{questions[currentSlide]}</p>
              <div className="flex justify-center gap-6 mt-4">
                {["Yes", "No"].map((val) => (
                  <button
                    key={val}
                    className={`px-6 py-2 rounded-full font-medium transition ${
                      answers[currentSlide] === val
                        ? "bg-red-500 text-white"
                        : "bg-gray-200 text-gray-800 hover:bg-black hover:text-white"
                    }`}
                    onClick={() => handleAnswer(currentSlide, val)}
                  >
                    {val}
                  </button>
                ))}
              </div>
              <div className="flex justify-center gap-10 mt-6">
                {currentSlide > 0 && (
                  <button
                    className="text-sm text-[#e53935] hover:text-black"
                    onClick={handlePrev}
                  >
                    ← Previous
                  </button>
                )}
                <button
                  className="text-sm text-[#e53935] hover:text-black"
                  onClick={handleNext}
                >
                  {currentSlide === questions.length - 1 ? "Submit" : "Next →"}
                </button>
              </div>
            </>
          ) : (
            <>
              <h2 className="text-xl font-bold text-center">Your Results</h2>
              <p className="text-center text-gray-600 mb-4">Score: {score}</p>
              {getRecommendation()}
              <div className="flex justify-center mt-6">
                <img
                  src={selfAssessmentImg}
                  alt="Self Assessment"
                  className="w-24 h-24"
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sizeup;